import api from 'api/api'
import { FlexView, LoadingOverlay } from 'components/common'
import FormCard from 'containers/form/upload/FormCard'
import StockTabs from 'containers/layout/StockTabs'
import UploadNominalBox from 'containers/upload/UploadNominalBox'
import { useWindowSize } from 'hooks/useWindowSize'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { AppContext } from 'stores/AppStore'
import { UploadContext } from 'stores/UploadStore'
import { UserContext } from 'stores/UserStore'
import styled from 'styled-components'
import { UPLOAD_TYPES } from 'utils/constants'
import { xlsxValidator } from 'utils/xlsxSchemaValidation'

const FlexWrap = styled(FlexView)`
    flex-wrap: wrap;
`

const FlexPage = styled(FlexView)`
    align-self: stretch;
    align-items: flex-start;
    margin: 0px 0px 0px 10px;
    width: calc(100% - 32px);
`

const UploadNominalData = () => {
    const { setPageSubtitle, pageLoading, setPageLoading } = useContext(AppContext)
    const { idToken } = useContext(UserContext)
    const { nominalFile, setSchemaErrors, setUploadData, schemaErrors, isUploading, setIsUploading, setNominalFile } =
        useContext(UploadContext)
    const { t } = useTranslation()
    const { height } = useWindowSize(0)
    const [deadSpace, setDeadSpace] = useState(0)

    useEffect(() => {
        setPageSubtitle(' - ' + t('Upload Nominal Data'))
    }, [setPageSubtitle, t])

    useEffect(() => {
        setDeadSpace(550)
    }, [height])

    useEffect(() => {
        async function validateSchema() {
            try {
                if (isUploading) {
                    setIsUploading(false)
                    setPageLoading(true)
                    const type = { schemaType: UPLOAD_TYPES.NOMINAL_DATA }
                    const schema = await api.getValidationSchema(type, idToken)
                    if (schema) {
                        xlsxValidator(
                            nominalFile,
                            (result) => {
                                if (result.errors === 'PIPE_DATA_QUANTITY_ERROR') {
                                    setNominalFile({})
                                    setPageLoading(false)
                                    setIsUploading(false)
                                    setSchemaErrors([])
                                    setUploadData([])
                                    toast.error(t(result.errors))
                                } else if (result.errors.length === 0) {
                                    setUploadData(result.data)
                                    setSchemaErrors([])
                                    setPageLoading(false)
                                } else {
                                    setSchemaErrors(result.errors)
                                    setUploadData([])
                                    setPageLoading(false)
                                    toast.error(t('Upload Error Message'))
                                }
                            },
                            schema,
                            UPLOAD_TYPES.NOMINAL_DATA,
                        )
                    }
                }
            } catch (error) {
                setNominalFile({})
                setPageLoading(false)
                setIsUploading(false)
                setSchemaErrors([])
                setUploadData([])
                toast.error(error.message)
            }
        }
        validateSchema()
    }, [
        nominalFile,
        idToken,
        setSchemaErrors,
        setPageLoading,
        t,
        setNominalFile,
        setUploadData,
        schemaErrors,
        setIsUploading,
        isUploading,
    ])

    return (
        <FlexPage>
            <LoadingOverlay visible={pageLoading} />
            <StockTabs group="upload"> </StockTabs>
            <FlexWrap flexDirection="row" alignItems="flex-start" alignSelf="stretch" margin="0" padding="0">
                <FormCard type={UPLOAD_TYPES.NOMINAL_DATA}> </FormCard>
            </FlexWrap>
            <UploadNominalBox height={height - deadSpace}> </UploadNominalBox>
        </FlexPage>
    )
}

export default UploadNominalData
